import React, { useContext } from "react";
import { StatisticsContainer, StatisticsContent } from "modules/common";
import { ReactComponent as EmailIcon } from "assets/icons/email.svg";
import { ReactComponent as MessengerIcon } from "assets/icons/messenger.svg";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    numberOfEmailUsers: number;
    numberOfAppUsers: number;
}
export const NotificationsStats: React.FC<Props> = ({ numberOfEmailUsers, numberOfAppUsers }) => {
    const { lowVision } = useContext(AccessibilityContext);
    return (
        <StatisticsContainer title="Broj korisnika po načinu obavještavanja" className={lowVision ? "low-vision-darkgray" : ""}>
            <StatisticsContent className="notifications-stats">
                <div className="notification-stats-row">
                    <EmailIcon className="notification-stats-icon" />
                    <p className="notification-stats-text">Email</p>
                </div>
                <div className="notification-stats-value">{numberOfEmailUsers}</div>
                <div className="notification-stats-row">
                    <MessengerIcon className="notification-stats-icon" />
                    <p className="notification-stats-text">Aplikacija</p>
                </div>
                <div className="notification-stats-value">{numberOfAppUsers}</div>
            </StatisticsContent>
        </StatisticsContainer>
    );
};
